import React, { useCallback, useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import {timeSince} from "../../utility";
import {INotification, TRecord} from "../../types/common";

const Index: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [expandedId, setExpandedId] = useState<string>("");
  const userSession = useRef(window.__USER_SESSION__).current;
  const [notificationList, setNotificationList] = useState<any[]>([
    /*{
      "label": "User Want a Leave Please Proceed the Action Of Leave User Want a Leave Please Proceed the Action Of Leave User Want a Leave Please Proceed the Action Of Leave",
      "type": "CONVERSATION",
      "channel": "HEADER_BELL_NOTIFICATION",
      "message": {
        "chatoutType": "QUESTION_OUT",
        "label": "User Want a Leave Please Proceed the Action Of Leave",
        "type": "CONVERSATION",
        "conversation": "{\"status\":\"success\",\"statusCode\":200,\"intent\":{\"_id\":\"67ec02c48781d10001369e7d\",\"name\":\"Runtime Conversation\",\"description\":\"\",\"isActive\":1,\"utterances\":[],\"isSystem\":false,\"createdAt\":\"2025-04-01T15:14:12.311Z\",\"updatedAt\":\"2025-04-01T15:14:12.311Z\",\"__v\":1,\"language\":\"en-GB\",\"style\":6,\"voiceName\":\"en-GB-Neural2-A\"},\"slots\":[{\"_id\":\"67ec02c48781d10001369e7e\",\"name\":\"isApprove\",\"slotType\":\"boolean\",\"prompt\":\"User Want a Leave Please Proceed the Action Of Leave\",\"promptString\":\"<p>User Want a Leave Please Proceed the Action Of Leave</p>\",\"fileType\":{\"type\":\"images\",\"isSecure\":false,\"buttonText\":\"\",\"maxSize\":0},\"required\":0,\"parentId\":null,\"parentValue\":null,\"order\":1,\"createdAt\":\"2025-04-01T15:14:12.311Z\",\"updatedAt\":\"2025-04-01T15:14:12.311Z\",\"promptSsml\":\"<speak>User Want a Leave Please Proceed the Action Of Leave</speak>\",\"promptSpeech\":{\"action\":\"talk\",\"text\":\"<speak>User Want a Leave Please Proceed the Action Of Leave</speak>\",\"tempText\":\"<p>User Want a Leave Please Proceed the Action Of Leave</p>\",\"isDtmf\":false,\"loop\":\"1\",\"language\":\"en-GB\",\"style\":6,\"voiceName\":\"en-GB-Neural2-A\"},\"promptAudio\":null,\"postProcessValidation\":false}],\"actions\":[{\"_id\":\"67ec02c48781d10001369e7f\",\"actionType\":\"callback\",\"actionValue\":\"\",\"actionValueLabel\":\"\",\"slots\":[],\"actionValueSpeech\":null,\"createdAt\":\"2025-04-01T15:14:12.311Z\",\"updatedAt\":\"2025-04-01T15:14:12.311Z\"}]}",
        "callback": "//seavault.myjourney36.com/robots/orchestration/callback/reply?refId=20fbebc5-bfab-462a-89eb-2aa479d31658&key=67ec02c4c1e644b6b051fddb"
      },
      "timestamp": 1743520452402
    }*/
  ]);

  useEffect(() => {
    if (typeof (window as any).J36 !== "undefined" && (window as any).J36.Notification) {
      setTimeout(() => {
        (window as any).J36.Notification.Subscribe("HEADER_BELL_NOTIFICATION", handleNotification);
        (window as any).addEventListener("message", handlePostMessage);
      }, 500)

      return () => {
        (window as any).J36.Notification.Unsubscribe("HEADER_BELL_NOTIFICATION", handleNotification);
        (window as any).removeEventListener("message", handlePostMessage);
      };
    }

    if (notificationList.length === 0) {
      setIsOpen(false);
    }

    return undefined;
  }, [notificationList, expandedId]);

  const togglePanel = () => {
    if (notificationList.length > 0) {
      setIsOpen(!isOpen);
    }
  };

  const handlePostMessage = useCallback(async (event: MessageEvent) => {
    if (event.data.messageType === "END_CONVERSATION") {
      (window as any).top.onChildComplete();
      if (typeof (window as any).J36 !== "undefined" && (window as any).J36.Notification) {
        await (window as any).J36.Notification.DeleteNotification(expandedId.toString());
      }
      setNotificationList(notificationList.filter((item) => item.messageId.toString() !== expandedId.toString()));
      handleClose();
      setIsOpen(false);
    }
  }, [expandedId, notificationList]);

  const handleNotification = (event: TRecord, messageId: string) => {
    const tempstamp = event.timestamp || Number(messageId.split("-")[0]);
    if (timeSince(tempstamp).toLowerCase() !== "invalid date") {
      const label = event?.data?.label || event?.data?.title || "New Notification";
      setNotificationList((prevItems) => {
        const newNotification = { messageId, ...event?.data?.message, ...event?.data, label, timestamp: tempstamp } as INotification;
        return prevItems.some((item) => item.messageId === messageId)
          ? prevItems
          : [newNotification, ...prevItems];
      });
    }
  };

  const handleExpend = (notification: INotification) => {
    setExpandedId(notification.messageId);
    let redirectionType = "";
    let pageId = "";
    let params: any = [];

    // Detect React Native WebView
    const isReactNativeWebView =
      typeof (window as any)?.ReactNativeWebView !== "undefined";

    // Optional: fallback mobile detection
    const isMobile =
      /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    let popup = !(isReactNativeWebView || isMobile);
    if (notification.type === "CONVERSATION") {
      redirectionType = "conversation"
      pageId = "1";
      params = [
        {
          key: "messageId",
          value: notification.messageId
        },
        {
          key: "runtimeConversation",
          value: true
        }
      ];
    } else if (notification.type === "SOCIAL_MEDIA") {
      redirectionType = notification.redirectionType || "page"
      pageId = notification.redirectionId || "68c970f70df8f087b47353a8";
      popup = popup || notification.popup || false;
      params = notification.params || []
      Promise.all(notificationList.map((item) => deleteNotification(item.messageId)))
    }

    const appMgr = (window as any).getAppWindow?.();
    (appMgr || window).navigateApp(redirectionType, pageId, params,
      {
        popup: popup
      }
    );

    if (notification.type === "CONVERSATION") {
      if (typeof (window as any).J36 !== "undefined" && (window as any).J36.Notification) {
        (window as any).J36.Notification.SendSubscription({
          userIds: [userSession?.id],
          channel: notification.messageId.toString(),
          data: {
            message: notification
          }
        });
      }
    }

    setIsOpen(false);
  };

  const handleClose = () => {
    setExpandedId("");
  };

  const deleteNotification = useCallback((messageId: string) => {
    setNotificationList(prevState => prevState.filter((item) => item.messageId !== messageId));
    if (typeof (window as any).J36 !== "undefined" && (window as any).J36.Notification) {
      (window as any).J36.Notification.DeleteNotification(messageId);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (notificationList.length === 0) {
        setIsOpen(false);
      }
    }, 500);
  }, [notificationList]);

  return (
    <div className={`${style.notification_section} notification_section`}>
      <div className={`${style.notification_bell} notification_bell`} onClick={togglePanel}>
        <div className={`${style.notification_icon_button} notification_icon_button`}>
          {notificationList.length > 0 ? (
            <>
              {isOpen ? (
                <div className={style.icon_wrapper}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       className="lucide lucide-x-icon lucide-x">
                    <path d="M18 6 6 18"/>
                    <path d="m6 6 12 12"/>
                  </svg>
                </div>
              ) : (
                <div className={style.icon_wrapper}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="10" style={{fill: 'var(--app36-primary)' }} fill="#222" />
                    <path
                      d="M6.1203 16.952H17.8797C18.2309 16.952 18.5054 16.8684 18.7032 16.7012C18.9011 16.534 19 16.311 19 16.0323C19 15.7789 18.9283 15.5332 18.7848 15.295C18.6414 15.0568 18.4609 14.8238 18.2432 14.5957C18.0306 14.3677 17.8179 14.1397 17.6052 13.9116C17.442 13.7394 17.3134 13.5139 17.2194 13.2352C17.1304 12.9565 17.0636 12.66 17.0191 12.3458C16.9746 12.0317 16.9424 11.7276 16.9226 11.4337C16.9078 10.4608 16.8039 9.5943 16.611 8.8342C16.4231 8.07411 16.1288 7.43563 15.7281 6.91876C15.3275 6.4019 14.7983 6.02185 14.1404 5.77862C14.0019 5.28203 13.7472 4.86144 13.3763 4.51686C13.0053 4.17229 12.5453 4 11.9963 4C11.4522 4 10.9947 4.17229 10.6237 4.51686C10.2528 4.86144 9.99806 5.28203 9.85957 5.77862C9.20173 6.02185 8.67002 6.4019 8.26444 6.91876C7.8638 7.43563 7.56951 8.07411 7.38156 8.8342C7.19361 9.5943 7.09221 10.4608 7.07737 11.4337C7.05759 11.7276 7.02544 12.0317 6.98092 12.3458C6.93641 12.66 6.86716 12.9565 6.77318 13.2352C6.68415 13.5139 6.55803 13.7394 6.39481 13.9116C6.18212 14.1397 5.96697 14.3677 5.74934 14.5957C5.53665 14.8238 5.35859 15.0568 5.21516 15.295C5.07172 15.5332 5 15.7789 5 16.0323C5 16.311 5.09892 16.534 5.29677 16.7012C5.49461 16.8684 5.76912 16.952 6.1203 16.952ZM11.9963 20C12.4167 20 12.7926 19.9063 13.124 19.7188C13.4554 19.5313 13.72 19.2855 13.9179 18.9815C14.1207 18.6774 14.2394 18.3481 14.274 17.9933H9.72602C9.7557 18.3481 9.87193 18.6774 10.0747 18.9815C10.2775 19.2855 10.5446 19.5313 10.876 19.7188C11.2074 19.9063 11.5808 20 11.9963 20Z"
                      fill="white"
                    />
                  </svg>
                  <div className={style.notification_badge}>
                    <span className={style.badge_count}>{notificationList.length}</span>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className={style.icon_wrapper}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="10" fill="#e0e0e0" />
                <path
                  d="M6.1203 16.952H17.8797C18.2309 16.952 18.5054 16.8684 18.7032 16.7012C18.9011 16.534 19 16.311 19 16.0323C19 15.7789 18.9283 15.5332 18.7848 15.295C18.6414 15.0568 18.4609 14.8238 18.2432 14.5957C18.0306 14.3677 17.8179 14.1397 17.6052 13.9116C17.442 13.7394 17.3134 13.5139 17.2194 13.2352C17.1304 12.9565 17.0636 12.66 17.0191 12.3458C16.9746 12.0317 16.9424 11.7276 16.9226 11.4337C16.9078 10.4608 16.8039 9.5943 16.611 8.8342C16.4231 8.07411 16.1288 7.43563 15.7281 6.91876C15.3275 6.4019 14.7983 6.02185 14.1404 5.77862C14.0019 5.28203 13.7472 4.86144 13.3763 4.51686C13.0053 4.17229 12.5453 4 11.9963 4C11.4522 4 10.9947 4.17229 10.6237 4.51686C10.2528 4.86144 9.99806 5.28203 9.85957 5.77862C9.20173 6.02185 8.67002 6.4019 8.26444 6.91876C7.8638 7.43563 7.56951 8.07411 7.38156 8.8342C7.19361 9.5943 7.09221 10.4608 7.07737 11.4337C7.05759 11.7276 7.02544 12.0317 6.98092 12.3458C6.93641 12.66 6.86716 12.9565 6.77318 13.2352C6.68415 13.5139 6.55803 13.7394 6.39481 13.9116C6.18212 14.1397 5.96697 14.3677 5.74934 14.5957C5.53665 14.8238 5.35859 15.0568 5.21516 15.295C5.07172 15.5332 5 15.7789 5 16.0323C5 16.311 5.09892 16.534 5.29677 16.7012C5.49461 16.8684 5.76912 16.952 6.1203 16.952ZM11.9963 20C12.4167 20 12.7926 19.9063 13.124 19.7188C13.4554 19.5313 13.72 19.2855 13.9179 18.9815C14.1207 18.6774 14.2394 18.3481 14.274 17.9933H9.72602C9.7557 18.3481 9.87193 18.6774 10.0747 18.9815C10.2775 19.2855 10.5446 19.5313 10.876 19.7188C11.2074 19.9063 11.5808 20 11.9963 20Z"
                  fill="#999"
                />
              </svg>
            </div>
          )}
        </div>
      </div>

      {isOpen && (
        <div className={style.notification_panel}>
          <div className={style.panel_arrow}></div>

          <div className={style.notification_panel_header}>
            <div className={style.header_content}>
              <h6 className={style.panel_title}>Notifications</h6>
              {notificationList.length > 0 && (
                <div className={style.count_badge}>
                  {notificationList.length}
                </div>
              )}
            </div>
            <button
              className={style.close_button}
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6L6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
          </div>

          <div className={style.notification_panel_body}>
            {notificationList.length > 0 ? (
              <div className={style.notifications_list}>
                {notificationList.map((notification: INotification, index) =>
                  notification.label ? (
                    <div key={index} className={style.notification_item}>
                      <div className={style.notification_content}>
                        <div className={style.notification_header}>
                          <span className={style.notification_type}>
                            {notification.type === "CONVERSATION" ? "Conversation" : "Alert"}
                          </span>
                          <span className={style.notification_time}>
                            {timeSince(notification.timestamp)}
                          </span>
                        </div>
                        <p className={style.notification_label}>{notification.label}</p>
                      </div>
                      <div className={style.notification_actions}>
                        {notification.type === "CONVERSATION" || notification.type === "SOCIAL_MEDIA" ? (
                          <button
                            className={`${style.action_button} ${style.open_button}`}
                            onClick={() => handleExpend(notification)}
                            aria-label="Open"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                              <polyline points="15 3 21 3 21 9" />
                            </svg>
                          </button>
                        ) : (
                          <button
                            className={`${style.action_button} ${style.delete_button}`}
                            onClick={() => deleteNotification(notification.messageId)}
                            aria-label="Delete"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            ) : (
              <div className={style.empty_state}>
                <div className={style.empty_icon}>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  </svg>
                </div>
                <h6 className={style.empty_title}>No notifications</h6>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
